import EyekandyEventLogging from "../abstracts/EyekandyEventLogging";

class EyekandySyndicationCoverageLogging extends EyekandyEventLogging {
  constructor(options) {
    super(options)
    //
    //  Set the values from our current class.
    this.destination = "syndicationCoverage"
    this.syndicatedByAllInOne = false
  }

  preLogCallback(payload) {
    //
    //  Ok, now return the payload exactly as it will be sent.
    return payload
  }

  log(sku, ean, mpn, upc, name, brand) {
    //
    //  Build our payload from the arguments given.
    const data = {
      type: "miss",
      sku: sku,
      ean: ean,
      mpn: mpn,
      upc: upc,
      name: name,
      brand: brand
    }
    //
    //  Send the log out, the keys: distributor/language/created are added by the pipeline.
    return this._log(data)
  }

  logAddToCart(sku, ean, mpn, upc, name, brand) {
    //
    //  Build our payload from the arguments given.
    const data = {
      type: "add-to-cart",
      sku: sku,
      ean: ean,
      mpn: mpn,
      upc: upc,
      name: name,
      brand: brand
    }
    //
    //  Send the log out, the keys: distributor/language/created are added by the pipeline.
    return this._log(data)
  }

  updateDistributor(distributor) {
    this.distributor = distributor
  }

  updateLanguage(language) {
    this.language = language
  }

  updateEnvironment(environment) {
    this.environment = environment
  }
}

//
//  :exports:
export default EyekandySyndicationCoverageLogging
